export default "__VITE_ASSET__f90eb9e3__"